// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__39Gmz","meals-appear":"Footer_meals-appear__3qHaF"};